(function($, Drupal) {
  Drupal.behaviors.customAccordion = {
    attach: function(context, settings) {
      $('.accordion-link', context).once('customAccordion').click(function(event) {
        // Prevent default link behavior
        event.preventDefault();

        // Toggle visibility of the related accordion content
        var content = $(this).next('.accordion-content');
        var isOpen = content.is(':visible');
        content.slideToggle('fast');
        $(this).attr('aria-expanded', !isOpen);
      });

      // Correctly handle clicks on links inside accordion content
      // This ensures that the event does not propagate further than intended.
      $('.accordion-content a', context).once('preventAccordionToggle').click(function(event) {
        // Allow default link behavior, but stop propagation to prevent triggering accordion toggle
        event.stopPropagation();
      });

      // Accordion groups tabs functionality
      $('.block-inline-blocktabbed-accordions').each(function() {
        let $block = $(this);
        let $buttons = $(this).find('button');
        let $tabs = $(this).find('.accordion-tab');
        $buttons.on('click', function() {
          if ($(this).hasClass('all-tabs')) {
            $tabs.show();
            $buttons.not($(this)).removeClass('is-active');
            $('.accordion-tabs__list').addClass('all-tabs');
            $(this).addClass('is-active');
          }
          else {
            $('.accordion-tabs__list').removeClass('all-tabs');
            $tabs.hide();
            $buttons.not($(this)).removeClass('is-active');
            $(this).addClass('is-active');

            // Open items if class is present
            $('#tab-' + $(this).attr('id'), context).find('.open-default').once('open-if-default').each(function(event) {
              var content = $(this).next('.accordion-content');
              content.show();
              $(this).attr('aria-expanded', true);
            });
            $('#tab-' + $(this).attr('id')).show();
          }
        });

        if ($block.find('.open-default').length && $block.find('.all-tabs').length === 0) {
          $block.find('.open-default').each(function(event) {
            var content = $(this).next('.accordion-content');
            content.show();
            $(this).attr('aria-expanded', true);
          });
        }
      });

      $('.block-inline-blockaccordion-block').each(function() {
        $(this, context).find('.open-default').once('open-initial-single').each(function(event) {
          var content = $(this).next('.accordion-content');
          content.show();
          $(this).attr('aria-expanded', true);
        });
      });
    }
  };
})(jQuery, Drupal);
